var styleDataHash = '58af625b';  
export const injectCss = (() => {
  var css = `.KlKyh{max-height:360px;overflow:auto}.oiFvj{padding:var(--wds-side-panel-content-padding-vertical,18px) var(--wds-side-panel-content-padding-horizontal,24px)}.tOFsp{display:flex;flex-direction:column-reverse}.rwvd7{overflow:hidden}._2qNiU{position:absolute;top:12px}[dir=ltr] ._2qNiU{right:6px}[dir=rtl] ._2qNiU{left:6px}.XSYKe [data-hook=progressbar-foreground]{transition:none!important}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "content": "KlKyh",
  "padded": "oiFvj",
  "contentScrollReverse": "tOFsp",
  "footer": "rwvd7",
  "closeButton": "_2qNiU",
  "progressIndicator": "XSYKe"
};